export const LS_BASKET_ID_KEY = 'basketID'
